/* Continuous auto-scroll for horizontal card scrollers, with the promo-bar
   contract: runs only while the section is in view, pauses on hover / touch /
   keyboard focus, and never runs under prefers-reduced-motion.

   Usage: data-auto-marquee="<px per second>" on the overflow-x element.
   Optional data-auto-marquee-track="<selector>" when the flex track is a child
   of the scroller (default: items are direct children of the scroller).

   Seamless loop: one full clone set is appended. Clones are aria-hidden with
   tabindex=-1 on focusables - clicks still work (all card actions on this site
   are event-delegated), but screen readers and Tab never meet the duplicates. */
(function () {
  if (window.__autoMarquee) return;
  window.__autoMarquee = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(scroller) {
    if (scroller.__mq) return;
    scroller.__mq = true;

    var speed = parseFloat(scroller.getAttribute('data-auto-marquee')) || 30;
    var innerSel = scroller.getAttribute('data-auto-marquee-track');
    var inner = innerSel ? scroller.querySelector(innerSel) : scroller;
    if (!inner) return;
    var originals = [].slice.call(inner.children);
    if (originals.length < 2) return;
    if (scroller.scrollWidth <= scroller.clientWidth + 8) return;

    originals.forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('img[loading="eager"]').forEach(function (img) {
        img.setAttribute('loading', 'lazy');
        img.removeAttribute('fetchpriority');
      });
      c.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (f) {
        f.setAttribute('tabindex', '-1');
      });
      inner.appendChild(c);
    });
    var firstClone = inner.children[originals.length];

    var rtl = getComputedStyle(scroller).direction === 'rtl';
    var loopW = 0;
    function measure() {
      loopW = Math.abs(originals[0].getBoundingClientRect().left - firstClone.getBoundingClientRect().left);
    }
    measure();

    scroller.style.scrollBehavior = 'auto';

    var inView = false;
    var paused = false;
    var engagedUntil = 0;
    var last = 0;
    // Float virtual position: scrollLeft assignment rounds to whole pixels,
    // so writing from an exact accumulator (never reading the rounded value
    // back into the math) is what keeps the real speed = `speed`.
    var pos = null;

    function active() {
      return inView && !paused && !document.hidden && Date.now() > engagedUntil && loopW > 0;
    }

    function tick(t) {
      requestAnimationFrame(tick);
      var dt = last ? Math.min(64, t - last) : 0;
      last = t;
      if (!active() || !dt) { pos = null; return; }
      // resync after user scrolls (readback rounding stays under 1px)
      if (pos === null || Math.abs(pos - scroller.scrollLeft) > 2) pos = scroller.scrollLeft;
      pos += (rtl ? -1 : 1) * speed * dt / 1000;
      if (Math.abs(pos) >= loopW) pos += rtl ? loopW : -loopW;
      scroller.scrollLeft = pos;
    }

    scroller.__mqDebug = function () {
      return { inView: inView, paused: paused, engagedUntil: engagedUntil, loopW: loopW, pos: pos, last: last };
    };

    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
    }, { threshold: 0.15 }).observe(scroller);

    scroller.addEventListener('mouseenter', function () { paused = true; });
    scroller.addEventListener('mouseleave', function () { paused = false; });
    scroller.addEventListener('focusin', function () { paused = true; });
    scroller.addEventListener('focusout', function () { paused = false; });
    // Touch / drag / wheel: back off, resume shortly after the user lets go.
    function engage() { engagedUntil = Date.now() + 3500; }
    scroller.addEventListener('touchstart', engage, { passive: true });
    scroller.addEventListener('touchmove', engage, { passive: true });
    scroller.addEventListener('pointerdown', engage, { passive: true });
    scroller.addEventListener('wheel', engage, { passive: true });

    var rT;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () { scroller.scrollLeft = 0; measure(); }, 250);
    });

    requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll('[data-auto-marquee]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
